module.exports = __webpack_public_path__ + "img/event_specail_deposit_bg3.bdf01621.png";